const Function = require('core/src/function');
const IAPI = require('core/src/api-client-abstract').default;
const _ = require('core/src/utils/legacy');
const deferredPromise = require('core/src/utils/deferred-promise');

let GremlinQuery = Function.extend(Function, 'GremlinQuery');

GremlinQuery.prototype.onInit = function (dependencies) {
	this.api = dependencies.get(IAPI);

	let params = {
		'$gremlin': '<required>',
		'$params': undefined,
		'$autoComplete': false,
		'$process': false,
		'$store': undefined
	};
	this.setParameters(params);

	let notRequired = {default: undefined, warn: _.def};
	this.setModelValidation({
		gremlin			: 'isString',
		params			: ['isObject', notRequired],
		autoComplete	: ['isBooleanParsable', {default: false, warn: _.def}],
		process			: ['isBooleanParsable', {default: false, warn: _.def}],
		store			: ['isString', notRequired]
	});
};

GremlinQuery.prototype.onExecute = function () {
	const promise = new Promise(async (resolve, reject) => {
		const gremlinQuery = {
			id: this.getId(),
			gremlin: this.getInput('gremlin'),
			params: this.getInput('params'),
			autoComplete: this.getInput('autoComplete'),
			process: this.getInput('process'),
			store: this.getInput('store')
		};

		try{
			const response = await this.api.executeGremlin(gremlinQuery);
			const event = {
				type: 'success',
				data: _.get(response, 'result.table'),
				processed: _.get(response, 'result.processed'),
				meta: {
					columns: _.get(response, 'resultInfo.columns'),
					nodecount: _.get(response, 'resultInfo.nodecount'),
					relcount: _.get(response, 'resultInfo.relcount'),
					gremlin: _.get(response, 'request.gremlin'),
					params: _.get(response, 'request.params'),
					store: _.get(response, 'request.store'),
					processData: _.get(response, 'request.process'),
					autoComplete: _.get(response, 'request.autoComplete'),
					status: _.get(response, 'status'),
					stats: _.get(response, 'meta.stats')
				}
			};

			this.executeTriggers(event);
			resolve(true);
		}
		catch (error) {
			reject(new _.Error({
				message: "Gremlin error: " + _.get(error, 'message'),
				data: error
			}));
		}
	});

	return deferredPromise(promise);
};

module.exports = GremlinQuery;
